import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { USER_DATA_INFO_QUERY_KEY } from "src/shared/enums/useQueryKeys";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";
import { disableImpersonation } from "../gateway";

function useDisableImpersonation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: disableImpersonation,
    mutationKey: ["disableImpersonation"],
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [USER_DATA_INFO_QUERY_KEY],
        exact: false,
      });
      navigate("/admin/applications");
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data ?? t("Σφάλμα"), {
        variant: "error",
      });
    },
  });
}

export default useDisableImpersonation;
